module.exports = __webpack_public_path__ + "img/BasketBlockImg.23166c42.png";